import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pickupdropprice } from "../store/slices/carrentalpackage";

import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";
import cardImg from "../assets/img/carImg-card.png";
import { Container, Row, Col, Form } from "react-bootstrap";

const PickupDrop = () => {
  const getISTDateTime = () => {
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    return new Date(now.getTime() + istOffset).toISOString().slice(0, 16);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Read query params
  const query = new URLSearchParams(location.search);
  const fromPlaceParam = query.get("fromPlace");
  const toPlaceParam = query.get("toPlace");
  const hotelName = query.get("hotelName");
  const pickupDate = query.get("pickupDate");

  const initialFromId = query.get("fromPlaceId");
  const initialToId = query.get("toPlaceId");

  // ------------------ STATE --------------------
  const [fromInput, setFromInput] = useState(fromPlaceParam || "");
  const [toInput, setToInput] = useState(toPlaceParam || "");

  const [fromPlaceIdState, setFromPlaceIdState] = useState(initialFromId || "");
  const [toPlaceIdState, setToPlaceIdState] = useState(initialToId || "");

  const [allPickupPlaces, setAllPickupPlaces] = useState([]);
  const [filteredPickupPlaces, setFilteredPickupPlaces] = useState([]);
  const [showPickupSuggestions, setShowPickupSuggestions] = useState(false);

  const [allDropPlaces, setAllDropPlaces] = useState([]);
  const [filteredDropPlaces, setFilteredDropPlaces] = useState([]);
  const [showDropSuggestions, setShowDropSuggestions] = useState(false);

  const [vehicleList, setVehicleList] = useState([]);
  const [loading, setLoading] = useState(false);

  // ---------------- FETCH VEHICLES FOR INITIAL SEARCH ----------------
  useEffect(() => {
    if (fromPlaceIdState && toPlaceIdState) {
      setLoading(true);

      dispatch(
        pickupdropprice({
          fromPlaceId: fromPlaceIdState,
          toPlaceId: toPlaceIdState,
        })
      )
        .unwrap()
        .then((data) => {
          const responseData = data?.pickupdropprice?.data;

          const route = responseData?.[0];

          if (route?.vehicle) {
            setVehicleList(route.vehicle);
          } else {
            setVehicleList([]);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [dispatch, fromPlaceIdState, toPlaceIdState]);

  // ---------------- PICKUP INPUT CHANGE ----------------
  const handlePickupChange = (e) => {
    const value = e.target.value;
    setFromInput(value);

    const filtered = allPickupPlaces.filter((p) =>
      p.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredPickupPlaces(filtered);
    setShowPickupSuggestions(true);
  };

  // ---------------- PICKUP SELECT → CALL API FOR DROPS ----------------
  const handleSelectPickup = (place) => {
    setFromInput(place.name);
    setFromPlaceIdState(place._id);
    setShowPickupSuggestions(false);

    // Now fetch drop list for this pickup place
    dispatch(pickupdropprice(place._id))
      .unwrap()
      .then((data) => {
        const drops =
          data?.pickupdropprice?.PriceData?.map((item) => item.toPlace) || [];

        setAllDropPlaces(drops);
        setFilteredDropPlaces(drops);
      });
  };

  // ---------------- DROP INPUT CHANGE ----------------
  const handleDropChange = (e) => {
    const value = e.target.value;
    setToInput(value);

    const filtered = allDropPlaces.filter((p) =>
      p.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredDropPlaces(filtered);
    setShowDropSuggestions(true);
  };

  // ---------------- SELECT DROP ----------------
  const handleSelectDrop = (place) => {
    setToInput(place.name);
    setToPlaceIdState(place._id);
    setShowDropSuggestions(false);
  };

  // ---------------- MODIFY SEARCH ----------------
  const handleModifySearch = () => {
    if (!fromPlaceIdState || !toPlaceIdState) {
      alert("Please select pickup and drop properly");
      return;
    }

    setLoading(true);

    dispatch(
      pickupdropprice({
        fromPlaceId: fromPlaceIdState,
        toPlaceId: toPlaceIdState,
      })
    )
      .unwrap()
      .then((response) => {
        const priceData = response?.data?.[0];
        setVehicleList(priceData?.vehicle || []);
      })
      .finally(() => setLoading(false));
  };

  // ---------------- BOOK NOW ----------------
  const handleBookNow = (vehicle) => {
    const params = new URLSearchParams({
      fromPlace: fromInput,
      toPlace: toInput,
      hotelName,
      pickupDate,
      fromPlaceId: fromPlaceIdState,
      toPlaceId: toPlaceIdState,
      vehicleId: vehicle.vehicle._id,
      price: vehicle.price,
    }).toString();

    navigate(`/pickup-drop-booking?${params}`);
  };

  return (
    <>
      <Navbarsticky />
      <div className="pickupdrop-container fluid"></div>

      <Container>
        <div className="pd-form d-flex  align-item-center justify-content-around my-4 mx-2 px-2">
          {/* ---------------- PICKUP INPUT ---------------- */}
          <Form.Group className="mb-1 mx-1 w-100 p-2">
            <Form.Label className="pd-filter-label">Pickup Location</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                value={fromInput}
                placeholder="Pickup Location"
                onChange={handlePickupChange}
                onFocus={() => setShowPickupSuggestions(true)}
              />
              <i className="bi bi-geo-alt"></i>
            </div>

            {/* SUGGESTIONS */}
            {showPickupSuggestions && filteredPickupPlaces.length > 0 && (
              <div className="suggestion-box">
                {filteredPickupPlaces.map((pl) => (
                  <div
                    key={pl._id}
                    className="suggestion-item"
                    onClick={() => handleSelectPickup(pl)}
                  >
                    {pl.name}
                  </div>
                ))}
              </div>
            )}
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* ---------------- DROP INPUT ---------------- */}
          <Form.Group className="mb-1 mx-1 w-100 p-2">
            <Form.Label className="pd-filter-label">Drop Location</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                value={toInput}
                placeholder="Drop Location"
                onChange={handleDropChange}
                onFocus={() => setShowDropSuggestions(true)}
              />
              <i className="bi bi-geo-alt"></i>
            </div>

            {/* DROP SUGGESTIONS */}
            {showDropSuggestions && filteredDropPlaces.length > 0 && (
              <div className="suggestion-box">
                {filteredDropPlaces.map((pl) => (
                  <div
                    key={pl._id}
                    className="suggestion-item"
                    onClick={() => handleSelectDrop(pl)}
                  >
                    {pl.name}
                  </div>
                ))}
              </div>
            )}
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* HOTEL NAME */}
          <Form.Group className="mb-3 mx-1 w-100 p-2">
            <Form.Label className="pd-filter-label">Hotel</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                value={hotelName}
                disabled
              />
              <i className="bi bi-buildings"></i>
            </div>
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* DATE & TIME */}
          <Form.Group className="mb-1 w-100 p-2">
            <Form.Label className="pd-filter-label">Date & Time</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="datetime-local"
                className="pd-filter-input"
                min={getISTDateTime()}
                value={pickupDate}
                disabled
              />
            </div>
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* MODIFY SEARCH */}
          <button
            className="take-tour-btn mt-2 w-50"
            style={{ maxHeight: "50px", fontSize: "12px", margin: "10px" }}
            onClick={handleModifySearch}
          >
            Modify Search <i className="bi bi-arrow-right ms-2" />
          </button>
        </div>

        <div className="container mt-5 pd-summary">
          <div className="d-flex flex-wrap justify-content-between ">
            <p style={{ marginRight: "8px" }}>
              <span className="summary-icon">
                <i className="bi bi-geo-alt-fill"></i>
              </span>
              <b style={{ fontSize: "12px" }}>Pickup Location:</b>{" "}
              <b style={{ fontSize: "14px", color: "#00a6e9" }}>{fromInput}</b>
            </p>

            <p style={{ marginRight: "8px" }}>
              <span className="summary-icon">
                <i className="bi bi-flag-fill"></i>
              </span>
              <b style={{ fontSize: "12px" }}>Drop Location:</b>{" "}
              <b style={{ fontSize: "14px", color: "#00a6e9" }}>{toInput}</b>
            </p>

            <p style={{ marginRight: "8px" }}>
              <span className="summary-icon">
                <i className="bi bi-building"></i>
              </span>
              <b style={{ fontSize: "12px" }}>Hotel:</b>{" "}
              <b style={{ fontSize: "14px", color: "#00a6e9" }}> {hotelName}</b>
            </p>

            <p style={{ marginRight: "8px" }}>
              <span className="summary-icon">
                <i className="bi bi-calendar-event-fill"></i>
              </span>
              <b style={{ fontSize: "12px" }}>Date & Time:</b>{" "}
              <b style={{ fontSize: "14px", color: "#00a6e9" }}>
                {pickupDate?.replace("T", " ")}
              </b>
            </p>

            <hr />
          </div>
        </div>
      </Container>

      {/* ---------------- VEHICLE LIST ---------------- */}
      <Container className="main-area">
        <Row>
          <Col lg={12} md={12}>
            <div className="results-header d-flex align-items-center justify-content-between">
              <h4 className="mb-3">Available Vehicles</h4>
              {loading && <p>Loading vehicle list...</p>}
              {!loading && vehicleList.length === 0 && (
                <p className="text-danger">No vehicles available.</p>
              )}
            </div>

            <Row xs={1} sm={2} md={3} lg={3} className="g-4">
              {vehicleList.map((v) => (
                <Col key={v.vehicle._id} className="mb-4">
                  <div className="vehicle-card-container">
                    <div className="vehicle-img-wrap">
                      <img
                        src={v.vehicle.carImage || cardImg}
                        alt={v.vehicle.carName}
                        className="vehicle-img"
                      />
                    </div>

                    <div className="vehicle-content">
                      <h5 className="vehicle-title">{v.vehicle.carName}</h5>

                      <p className="vehicle-seats">
                        <i className="bi bi-people-fill"></i> &nbsp;
                        {v.vehicle.minMember} – {v.vehicle.maxMember} Seats
                      </p>

                      <h5
                        className="vehicle-price"
                        style={{ color: "#00a6e9", fontWeight: "bold" }}
                      >
                        ₹ {v.price}
                      </h5>

                      <button
                        className="btn take-tour-btn"
                        onClick={() => handleBookNow(v)}
                      >
                        Book Now <i className="bi bi-arrow-right ms-2" />
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default PickupDrop;
